<template>
    <div class="container-fluid">
        <h1>{{$t('components.news.categories')}}</h1>
        <div class="card card-body shadow" ref="container">
            <div v-for="category in categories" :key="`${category.id}_${$store.getters['langStore/current']}`">
                <div class="row mb-5" v-if="category.latest_news.length > 0">
                    <div class="col-sm-12">
                        <h2>{{category.name}}</h2>
                        <p v-html="category.description"></p>
                        <hr>
                        <div class="row">
                            <div class="col-sm-12 col-md-4" v-for="item in category.latest_news" :key="'news_item'+item.id+'_'+$store.getters['langStore/current']">
                                <NewsCard :item="item"/>
                            </div>
                        </div>
                        <div class="row mt-5" v-if="category.news_count > 3">
                            <div class="col-sm-12 text-center">
                                <router-link class="w-25 btn btn-wos-real" :to="{name: 'app.news.category', params: {slug: category.slug}}">
                                    {{$t('components.news.btnGoToCategory')}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsApiService from "@/api/news.api";
import {EVENT_LANG_CHANGE} from "@/core/constants";
import NewsCard from "@/components/application/NewsCard";
import {empty} from "@/helpers";

export default {
    name: "News",
    components: {NewsCard},
    data() {
        return {
            items: []
        }
    },

    mounted() {
        this.fetch();

        this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
            this.fetch();
        });
    },

    destroyed() {
        this.$eventBus.$off(EVENT_LANG_CHANGE);
    },

    methods: {
        fetch() {
            this.showLoader();
            NewsApiService.categories()
                .then(response => this.items = response.data.items)
                .finally(() => this.hideLoader());
        },

        showLoader: function () {
            if (!empty(this.loader)) {
                this.loader.hide();
                this.loader = null;
            }
            this.loader = this.$loading.show({
                container: this.$refs.container
            });
        },

        hideLoader: function () {
            if (!empty(this.loader)) {
                this.loader.hide();
                this.loader = null;
            }
        }
    },

    computed: {
        categories() {
            return this.items;
        }
    }
}
</script>

<style scoped>

</style>
